import { UserInfo } from '@/common/types';
import {
  EMAIL_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN,
  NAME_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN,
} from '@/constants/contact';
import { appendElement } from '../xml-helpers';

/**
 * Formats a Date as a Crossref timestamp string: YYYYMMDDHHmmssSSS
 */
export function formatTimestamp(date: Date): string {
  return (
    String(date.getFullYear()) +
    String(date.getMonth() + 1).padStart(2, '0') +
    String(date.getDate()).padStart(2, '0') +
    String(date.getHours()).padStart(2, '0') +
    String(date.getMinutes()).padStart(2, '0') +
    String(date.getSeconds()).padStart(2, '0') +
    String(date.getMilliseconds()).padStart(3, '0')
  );
}

/**
 * Builds the `<head>` element of a Crossref deposit, containing
 * doi_batch_id, timestamp, depositor info, and registrant.
 */
export function buildHead(parent: Element, userInfo?: UserInfo): Element {
  const head = appendElement(parent, 'head');
  appendElement(head, 'doi_batch_id', 'NONE');
  appendElement(head, 'timestamp', formatTimestamp(new Date()));

  const depositor = appendElement(head, 'depositor');
  appendElement(
    depositor,
    'depositor_name',
    userInfo?.depositorName || NAME_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN
  );
  appendElement(
    depositor,
    'email_address',
    userInfo?.depositorEmail || EMAIL_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN
  );

  appendElement(head, 'registrant', 'content-registration-form');

  return head;
}
